/* shah */
import React from 'react'

const ZoomOutSmIcon = () => {
    return (
        <svg className="ContentSVG" version="1.0" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            >
                <path d="M150 5017 c-19 -12 -43 -37 -53 -55 -22 -38 -26 -116 -7 -153 7 -13
242 -255 524 -536 l511 -513 -390 0 c-372 0 -392 -1 -423 -20 -48 -30 -72 -75
-72 -140 0 -65 24 -110 72 -140 32 -19 52 -20 648 -20 596 0 616 1 648 20 18
11 41 34 52 52 19 32 20 52 20 648 0 596 -1 616 -20 648 -30 48 -75 72 -140
72 -65 0 -110 -24 -140 -72 -19 -31 -20 -51 -20 -423 l0 -390 -512 511 c-282
282 -523 517 -535 523 -39 20 -126 14 -163 -12z"/>
                <path d="M4805 5029 c-11 -6 -251 -241 -532 -523 l-513 -511 0 390 c0 372 -1
392 -20 423 -30 48 -75 72 -140 72 -65 0 -110 -24 -140 -72 -19 -32 -20 -52
-20 -648 0 -596 1 -616 20 -648 11 -18 34 -41 52 -52 32 -19 52 -20 648 -20
596 0 616 1 648 20 48 30 72 75 72 140 0 65 -24 110 -72 140 -31 19 -51 20
-423 20 l-390 0 511 513 c282 281 517 523 524 536 19 37 15 115 -7 153 -31 53
-77 78 -142 78 -31 0 -65 -5 -76 -11z"/>
                <path d="M1952 3339 c-71 -28 -144 -101 -171 -174 -20 -54 -21 -73 -21 -605 0
-532 1 -551 21 -605 28 -74 100 -146 174 -174 54 -20 73 -21 605 -21 532 0
551 1 605 21 74 28 146 100 174 174 20 54 21 73 21 605 0 532 -1 551 -21 605
-28 74 -100 146 -174 174 -54 20 -72 21 -608 20 -530 0 -554 -1 -605 -20z"/>
                <path d="M312 1660 c-48 -30 -72 -75 -72 -140 0 -65 24 -110 72 -140 31 -19
51 -20 423 -20 l390 0 -511 -512 c-282 -282 -517 -524 -524 -537 -19 -37 -15
-115 7 -153 30 -52 77 -78 140 -78 30 0 64 5 76 11 12 6 253 241 535 523 l512
511 0 -390 c0 -372 1 -392 20 -423 30 -48 75 -72 140 -72 65 0 110 24 140 72
19 32 20 52 20 648 0 596 -1 616 -20 648 -11 18 -34 41 -52 52 -32 19 -52 20
-648 20 -596 0 -616 -1 -648 -20z"/>
                <path d="M3512 1660 c-18 -11 -41 -34 -52 -52 -19 -32 -20 -52 -20 -648 0
-596 1 -616 20 -648 30 -48 75 -72 140 -72 65 0 110 24 140 72 19 31 20 51 20
423 l0 390 513 -511 c281 -282 522 -517 534 -523 12 -6 46 -11 76 -11 63 0
110 26 140 78 22 38 26 116 7 153 -7 13 -242 255 -524 537 l-511 512 390 0
c372 0 392 1 423 20 48 30 72 75 72 140 0 65 -24 110 -72 140 -32 19 -52 20
-648 20 -596 0 -616 -1 -648 -20z"/>
            </g>
        </svg>

    )
}

export default ZoomOutSmIcon